<template>
    <el-card>
        <div slot='header'>
            <el-button
             v-for="(item, index) in serverTab"
             :key="item.name"
             :type='item.name === isSelect ? "primary": "" '
             @click="selectType(index)"
             class="topButton">
                {{item.title}}
            </el-button>
        </div>

        <el-table :data="tableData" highlight-current-row >

            <el-table-column label="slat-id" prop='hostname'>
                <!-- <template slot-scope="scope">
                    <router-link :to='{path:"/detailServer" , query: { host_id: scope.row.id }}'>
                        <el-button type="text">{{scope.row.hostname}}</el-button>
                    </router-link>
                </template> -->
            </el-table-column>

            <el-table-column label="IP" prop='ip'></el-table-column>

            <el-table-column label="类型">
                <template slot-scope="scope">
                    {{tableVal(scope.row.type,env) }}
                </template>
            </el-table-column>

            <el-table-column label="环境">
                <template slot-scope="scope">
                    {{ tableVal(scope.row.env,env) }}
                </template>
            </el-table-column>

            <el-table-column label="状态">
                <template slot-scope="scope">
                    {{ tableVal(scope.row.status,server_status) }}
                </template>
            </el-table-column>

            <el-table-column label="配置">
                <template slot-scope="scope">
                    <p>磁盘: {{scope.row.disk}} </p>
                    <p>操作系统: {{scope.row.os}} </p>
                    <p>CPU: {{scope.row.cpu}} </p>
                    <p>内存: {{scope.row.memory}} </p>
                </template>
            </el-table-column>

            <el-table-column label="发布所属组" prop='ci_group'></el-table-column>

            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click='unbind(scope.row, tableData, scope.$index)' >解绑</el-button>
                    <!--//v-w-role="'cicdCxjcYysYybj'"-->
                </template>
            </el-table-column>

        </el-table>

    </el-card>
</template>

<script>
    import services from '../../cicd.services'
    export default {

        data() {
            return {
                serverTab: [],
                index: 0,
                detailForm: {}
            }
        },

        watch: {
            parentId(newVal) {
                this.getDetail()
            }
        },

        computed: {
            isSelect() {
                return this.serverTab[this.index] ? this.serverTab[this.index].name : []
            },
            tableData() {
                return this.serverTab[this.index] ? this.serverTab[this.index].content : []
            },
            dictionary() {
                return this.$store.state.dictionary2
            },
            env() {
                return this.dictionary.env
            },
            server_status() {
                return this.dictionary.server_status
            },
            parentId() {
                return this.$route.query.id
            }
        },

        mounted() {
            this.getDetail()
        },

        methods: {
            // 解绑
            unbind(row, rows, index) {
                this.$confirm('确定要解绑吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        let params = {
                            appId: this.parentId,
                            serverId: row.id,
                            env: this.isSelect 
                        }
                        services.serverNtying(params)
                            .then(res => {
                                rows.splice(index, 1)
                                this.$message.success('解除成功')
                            })
                            .catch(err => this.$message.error(err.message))
                    })
                    .catch(() => this.$message.info('已取消删除'))
            },

            selectType(index) {
                this.index = index
            },

            // 获取详情
            getDetail() {
                services.nodeInfo( { appId: this.parentId } )
                    .then(res => {
                        this.serverTab = res.env.map((item, index) => {
                            return {
                                name: item,
                                title: this.getNameByDefault(item, this.env),
                                content: res.server.filter(i => i.env === item)
                            }
                        })
                    })
                    .catch(err => this.$message.error(err.message))
            },
            // 根据数据字典取值
            tableVal(value, arr) {
                if(!arr) return '无'
                if(arr && arr.length == 0) return "无"
                let res = arr.filter(item => item.default == value)
                let str = ""
                if(!res.length) str =  "无"
                str = res[0].cname
                return str
            },
        }

    }
</script>

<style>

</style>
